export default {
    API_ROOT_URL: process.env.REACT_APP_API_ROOT,
    IS_DEV: false,
    TOKEN: 'Wagon2021',
    LANG: 'Lang',
    TIMEZONE: 'TimeZone',
    USERNAME: 'UserName'
};